import { COMMON_LINK_QUERY } from '@/gql/fragments/common.gql';
import { useQuery } from '@apollo/client';
import { parseCommonLink, parseCommonLinkFragment } from '../parsers/common/parseCommonLinks';

export default function useCommonLinks() {
  const { data } = useQuery(COMMON_LINK_QUERY);

  return {
    home: parseCommonLinkFragment(data?.home),
    search: parseCommonLinkFragment(data?.search),
    articleIndex: parseCommonLinkFragment(data?.articleIndex),
    eventIndex: parseCommonLink(data?.eventIndex),
    mediaIndex: parseCommonLink(data?.mediaIndex),
  };
}
